export const version = "providers/5.2.0";
//# sourceMappingURL=_version.js.map